// @ts-nocheck
const MessagesSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default MessagesSkeleton